import React from 'react';
import styled from '@emotion/styled';
import { useWindowSize } from '../../core/utils/Hooks';
import { isUp } from '../../core/utils/Breakpoints';
import { mixins } from '../../core/styles/theme/default';
import { Stack } from '../../helpers';
import Link, { LinkProps } from '../../primitives/Link';

import { BreakpointsInterface, SpaceInterface } from '../../types';

const StyledList = styled(Stack)`
  ${mixins.listReset};
`;

const LinkList = ({
  links,
  stackSpace = 'regular',
  ...rest
}: LinkListProps) => {
  const { width: windowWidth } = useWindowSize();
  const hasLinks = links.length > 0;

  return hasLinks && windowWidth ? (
    <StyledList component="ul" space={stackSpace} {...rest}>
      {links.map(({ linkText, showFrom = 'zero', isHighlighted, ...rest }) =>
        isUp(showFrom, windowWidth) ? (
          <Link
            key={linkText}
            linkText={linkText}
            color={isHighlighted ? 'secondary' : undefined}
            {...rest}
          />
        ) : null,
      )}
    </StyledList>
  ) : null;
};

export interface LinkListInterface extends LinkProps {
  /** Is the Link highlighted */
  isHighlighted?: boolean;
  /** Show the Link starting with the chosen Breakpoint - default: **zero** */
  showFrom?: BreakpointsInterface;
}

export type LinkListProps = {
  /** Links of the LinkList */
  links: LinkListInterface[];
  /** spacingCurve Name which will get passed to the Stack around the Links */
  stackSpace?: SpaceInterface;
};

export default LinkList;
